import { createStore } from "vuex";

function readLocalStorage(key, fallback = "") {
    if (typeof window === "undefined") return fallback;
    return window.localStorage?.getItem(key) || fallback;
}

function writeLocalStorage(key, value) {
    if (typeof window === "undefined") return;
    if (value === "" || value == null) {
        window.localStorage?.removeItem(key);
        return;
    }
    window.localStorage?.setItem(key, value);
}

function removeTokenFromUrl() {
    if (typeof window === "undefined") return;

    try {
        const url = new URL(window.location.href);
        url.searchParams.delete("token");

        const hash = url.hash || "";
        if (hash.includes("?")) {
            const rawHash = hash.slice(1);
            const queryIndex = rawHash.indexOf("?");
            const hashPath = rawHash.slice(0, queryIndex);
            const hashQuery = rawHash.slice(queryIndex + 1);
            const hashParams = new URLSearchParams(hashQuery);
            hashParams.delete("token");
            const nextHashQuery = hashParams.toString();
            url.hash = nextHashQuery ? `${hashPath}?${nextHashQuery}` : hashPath;
        }

        window.history?.replaceState?.(window.history.state, document.title, url.toString());
    } catch (error) {
        window.localStorage?.removeItem("token");
    }
}

const store = {
    state: {
        token: readLocalStorage("token"),
        user: {},
        code: "",

        express_phone_erp: "",
        express_phone_sys: "",

        apply_info: {
            checked: -1,
        },
    },
    mutations: {
        setToken(state, token) {
            state.token = token || "";
            writeLocalStorage("token", token || "");
        },
        logout(state) {
            state.token = "";
            state.user = {};
            writeLocalStorage("token", "");
            removeTokenFromUrl();
        },
        SET_USER_INFO(state, user) {
            state.user = user;
        },
        SET_CODE(state, code) {
            state.code = code;
        },
        SET_STATE(state, { key, value }) {
            state[key] = value;
        },
    },
    getters: {},
    actions: {
        setApplyInfo({ commit }, info) {
            commit("SET_STATE", {
                key: "apply_info",
                value: info,
            });
        },
    },
};

export default createStore(store);
